import * as React from "react";
import moment from "moment";

import { Input, DatePicker, Form } from "antd";
import DropdownInputAnt from "src/components/forms/DropdownInputAnt";
import DatasetAuthorizationWrapper from "src/common/DatasetAuthorizationWrapper";

import * as DropdownIOption from "src/components/forms/Dropdown";

import PickListContext from "src/context/pickListContext";
import OrganizationAPI from "src/admin/Organization/API/OrganizationAPI";
import AssessmentResultsAPI from "src/admin/results/AssessmentResultsAPI";
import DatasetAPI from "src/admin/Organization/Datasets/DatasetAPI";
import LocationAPI from "src/admin/Organization/Location/LocationAPI";
import CoreAPI from "./CoreAPI";

import { Spinner } from "src/components/common";
import { Button } from "src/components/buttons";
import { ClientPermissions } from "src/common/Permissions";
// tslint:disable-next-line:max-line-length
import {
	CustomFieldContainer,
	getCustomFieldValues,
	getCustomFieldValidation,
	ICustomFieldValidation,
} from "src/admin/Organization/CustomFields/CustomFieldContainer";
import Dropdown from "src/components/forms/Dropdown";
import { Prompt } from "react-router-dom";
import { hasAnyExceleRATEProduct } from "src/components/forms/ProductType";
import Utils, {
	Validation,
	CommercialDrivingExpValueMap,
} from "src/common/utils";
import { toast } from "react-toastify";

interface IProps {
	match?: any;
	history?: any;
}

interface IState {
	customFields: CustomFieldDTO[];
	coreTestCustomFieldValidation: string[];
	courses: CourseWithLocationNameDTO[];
	locations: LocationDTO[];
	vehicleTypes: PickListItemResponseDTO[];
	evaluators: OrganizationUserDTO[];
	dataset: DatasetDTO;
	coreTest: CoreTestResultDTO;
	locationId: number | undefined;
	courseId: number | undefined;
	vehicleTypeId: number | undefined;
	startTimeHour: number | undefined;
	startTimeMinutes: number | undefined;
	startTimeOfDay: number | undefined;
	endTimeOfDay: number | undefined;
	endTimeHour: number | undefined;
	endTimeMinutes: number | undefined;
	isLoading: boolean;
	isDirty: boolean;
	dataLocked: boolean;
	commercialDrivingExpSettings: CommercialDrivingExpSettingsDTO;
}

class CoreGeneral extends React.Component<IProps, IState> {
	public static contextType = PickListContext;
	public state = {
		customFields: [] as CustomFieldDTO[],
		courses: [] as CourseWithLocationNameDTO[],
		locations: [] as LocationDTO[],
		vehicleTypes: [] as PickListItemResponseDTO[],
		evaluators: [] as OrganizationUserDTO[],
		dataset: {} as DatasetDTO,
		locationId: undefined,
		courseId: undefined,
		vehicleTypeId: undefined,
		coreTest: { dateAdministered: "" } as CoreTestResultDTO,
		coreTestCustomFieldValidation: [],
		startTimeHour: undefined,
		startTimeMinutes: undefined,
		startTimeOfDay: undefined,
		endTimeHour: undefined,
		endTimeMinutes: undefined,
		endTimeOfDay: undefined,
		isLoading: true,
		isDirty: false,
		dataLocked: true,
		commercialDrivingExpSettings: {} as CommercialDrivingExpSettingsDTO,
	};

	private currentDate = moment();

	public componentDidMount() {
		const { organizationId, datasetId, clientId, coreId, sessionId } =
			this.props.match.params;

		if (+sessionId === 0) {
			this.setState({ dataLocked: false });
		} else {
			AssessmentResultsAPI.getSession({ datasetId, clientId, sessionId }).then(
				(session) => {
					this.setState({
						dataLocked: session.dataLocked === false ? false : true,
					});
				}
			);
		}

		OrganizationAPI.getCommercialDrivingExpSettings({
			tenantId: organizationId,
			datasetId: datasetId,
		}).then((settings) => {
			this.setState({ commercialDrivingExpSettings: settings });
		});

		DatasetAPI.getClientSiteOrganizationDataset(organizationId, datasetId)
			.then((dataset) => this.setState({ dataset }))
			.then(() => {
				LocationAPI.getClientSiteDatasetLocations({
					organizationId,
					datasetId,
				}).then((locations) => {
					this.setState({ locations });
				});
				DatasetAPI.getDatasetVehicleTypes({
					organizationId,
					datasetId,
				})
					.then((vehicleTypes) => {
						this.setState({ vehicleTypes });
					})
					.then(() => {
						CoreAPI.getClientsiteCourses({
							organizationId,
							datasetId,
						})
							.then((courses) => this.setState({ courses }))
							.then(() => {
								CoreAPI.getCoreTest({
									datasetId,
									clientId,
									coreTestId: coreId,
								})
									.then((test) => {
										const { locations, courses } = this.state;
										if (!test.dateAdministered) {
											test.dateAdministered = moment().format("MMM DD, YYYY");
										} else {
											test.dateAdministered = moment
												.utc(test.dateAdministered)
												.local()
												.format("MMM DD, YYYY");
										}

										if (locations.length == 1 && !test.locationId) {
											test.locationId = locations[0].id;
										}

										if (courses.length == 1 && !test.courseId) {
											test.courseId = courses[0].id;
										}

										this.convertTestTime(test.startTime!, "startTime");
										this.convertTestTime(test.endTime!, "endTime");
										this.setState({
											coreTest: test,
											locationId: test.locationId,
											courseId: test.courseId,
											isLoading: false,
										});
									})
									.then(() => {
										OrganizationAPI.getDatasetEvaluators({
											tenantId: organizationId,
											datasetId,
										}).then((evaluators) => {
											var evaluator = evaluators.find(
												(x) => x.id === this.state.coreTest.evaluatorId
											);
											if (evaluator || !this.state.coreTest.evaluatorId) {
												this.setState({ evaluators });
											} else {
												// Retrieve user record for selected evaluator if they aren't already in the list
												OrganizationAPI.getEvaluator({
													tenantId: organizationId,
													datasetId,
													evaluatorId: this.state.coreTest.evaluatorId,
												}).then((selectedEvaluator) => {
													evaluators.push(selectedEvaluator);
													this.setState({ evaluators });
												});
											}
										});
									});
							});
					});
			});
	}

	public componentDidUpdate(prevProps: any, prevState: any) {
		if (
			this.state.coreTest !== prevState.coreTest &&
			this.state.coreTest.id === prevState.coreTest.id &&
			!this.state.isDirty
		) {
			this.setState({ isDirty: true });
		}
	}

	public render() {
		const {
			evaluators,
			coreTest,
			courses,
			locations,
			vehicleTypes,
			dataset,
			commercialDrivingExpSettings,
		} = this.state;
		const validCoreTestResult = {
			cooperative: Validation.validateIfANumberOrNumbers(
				coreTest.cooperativeId!
			),
			course: Validation.validateIfANumberOrNumbers(coreTest.courseId!),
			hearing: Validation.validateIfANumberOrNumbers(
				coreTest.hearingImpairmentId!
			),
			visual: Validation.validateIfANumberOrNumbers(
				coreTest.visualImpairmentId!
			),
			anxiety: Validation.validateIfANumberOrNumbers(coreTest.anxietyLevelId!),
			physical: Validation.validateIfANumberOrNumbers(
				coreTest.physicalImpairmentId!
			),
			evaluator: Validation.validateIfANumberOrNumbers(coreTest.evaluatorId!),
			vehicleType: Validation.validateIfANumberOrNumbers(
				coreTest.vehicleTypeId!
			),
			difficultyLevel: Validation.validateIfANumberOrNumbers(
				coreTest.difficultyLevelId!
			),
			dateAdministered: Validation.validateStringIsNotEmpty(
				coreTest.dateAdministered!,
				"Please Choose a date"
			),
			weather: Validation.validateIfANumberOrNumbers(
				coreTest.weatherRoadConditionsId!
			),
			location: Validation.validateIfANumberOrNumbers(coreTest.locationId!),
			commDrvExp:
				hasAnyExceleRATEProduct(dataset.productId) &&
				commercialDrivingExpSettings.showCommDrivingExp &&
				commercialDrivingExpSettings.requireCommDrivingExp
					? Validation.validateIfANumberOrNumbers(
							coreTest.monthsCommercialDrivingExp!
					  )
					: {
							validationStatus: undefined,
							message: "",
					  },
			customFieldValues:
				this.state.coreTestCustomFieldValidation.length > 0
					? this.state.coreTestCustomFieldValidation
					: [],
		};

		const evaluatorOptions = this.setEvaluatorOptions(evaluators);
		const courseOptions = this.setCourseOptions(courses);
		const locationOptions = this.setLocationOptions(locations);
		const vehicleTypeOptions = this.setVehicleTypeOptions(vehicleTypes);
		const { dataLocked } = this.state;

		return this.state.isLoading !== false ? (
			<Spinner />
		) : (
			<div className="container-fluid">
				<Prompt when={this.state.isDirty} message="Exit without saving?" />
				<div className="row">
					{!coreTest.mobile ? (
						<div className="col-md-6 col-lg-4 form-group">
							<label htmlFor="dateAdministered">Date administered *</label>
							<Form.Item
								validateStatus={
									validCoreTestResult.dateAdministered.validationStatus
								}
								help={validCoreTestResult.dateAdministered.message}
								hasFeedback={true}
								required={true}
							>
								<DatePicker
									id="dateAdministered"
									value={moment(coreTest.dateAdministered)}
									onChange={(value: any) =>
										this.onDateChange(value ? value : moment())
									}
									format="MMM DD, YYYY"
									disabled={dataLocked}
									disabledDate={(date) =>
										date ? date > this.currentDate : true
									}
								/>
							</Form.Item>
						</div>
					) : null}
					{!coreTest.mobile ? (
						<div className="col-md-6 col-lg-4 form-group">
							<label>Start time</label>
							<Form.Item>
								<DropdownInputAnt
									name="startTimeHour"
									placeholder=""
									id="startTimeHour"
									pickListCode="CountDropdownOptions"
									parentCode="Hour"
									value={this.state.startTimeHour}
									onChange={(value: any) =>
										this.onStartAndEndTimeChange(value, "startTimeHour")
									}
									disabled={dataLocked || this.state.coreTest.mobile}
								/>
								<span className="d-flex align-items-center justify-content-center px-2 font-weight-bold">
									:
								</span>
								<DropdownInputAnt
									name="startTimeMinutes"
									placeholder=""
									className="mr-3"
									id="startTimeMinutes"
									pickListCode="CountDropdownOptions"
									parentCode="Minute"
									value={this.state.startTimeMinutes}
									onChange={(value: any) =>
										this.onStartAndEndTimeChange(value, "startTimeMinutes")
									}
									disabled={dataLocked || this.state.coreTest.mobile}
								/>
								<DropdownInputAnt
									name="startTimeOfDay"
									placeholder=""
									id="startTimeOfDay"
									pickListCode="CountDropdownOptions"
									parentCode="DayOrNight"
									value={this.state.startTimeOfDay}
									onChange={(value: any) =>
										this.onStartAndEndTimeChange(value, "startTimeOfDay")
									}
									disabled={dataLocked || this.state.coreTest.mobile}
								/>
							</Form.Item>
						</div>
					) : null}
					{!coreTest.mobile ? (
						<div className="col-md-6 col-lg-4 form-group">
							<label>End time</label>
							<Form.Item>
								<DropdownInputAnt
									name="endTimeHour"
									placeholder=""
									pickListCode="CountDropdownOptions"
									parentCode="Hour"
									value={this.state.endTimeHour}
									onChange={(value: any) =>
										this.onStartAndEndTimeChange(value, "endTimeHour")
									}
									disabled={dataLocked || this.state.coreTest.mobile}
								/>
								<span className="d-flex align-items-center justify-content-center px-2 font-weight-bold">
									:
								</span>
								<DropdownInputAnt
									name="endTimeMinute"
									className="mr-3"
									placeholder=""
									pickListCode="CountDropdownOptions"
									parentCode="Minute"
									value={this.state.endTimeMinutes}
									onChange={(value: any) =>
										this.onStartAndEndTimeChange(value, "endTimeMinutes")
									}
									disabled={dataLocked || this.state.coreTest.mobile}
								/>
								<DropdownInputAnt
									name="endTimeOfDay"
									placeholder=""
									pickListCode="CountDropdownOptions"
									parentCode="DayOrNight"
									value={this.state.endTimeOfDay}
									onChange={(value: any) =>
										this.onStartAndEndTimeChange(value, "endTimeOfDay")
									}
									disabled={dataLocked || this.state.coreTest.mobile}
								/>
							</Form.Item>
						</div>
					) : null}
					<div className="col-md-6 col-lg-4 form-group">
						<label>Location *</label>
						<Form.Item
							validateStatus={validCoreTestResult.location.validationStatus}
							help={validCoreTestResult.location.message}
							hasFeedback={true}
							required={true}
						>
							<Dropdown
								id="locationId"
								name="locationId"
								placeholder="Select a Location"
								value={
									coreTest.locationId
										? [
												{
													value: coreTest.locationId,
													label: (
														locationOptions.find(
															(x) =>
																x.key ===
																(coreTest.locationId
																	? coreTest.locationId.toString()
																	: "")
														) || { label: "" }
													).label,
												},
										  ]
										: undefined
								}
								options={locationOptions}
								onChange={this.setCoreTestLocation}
								disabled={dataLocked}
							/>
						</Form.Item>
					</div>
					<div className="col-md-6 col-lg-4 form-group">
						<label>Course *</label>
						<Form.Item
							validateStatus={validCoreTestResult.course.validationStatus}
							help={validCoreTestResult.course.message}
							hasFeedback={true}
							required={true}
						>
							<Dropdown
								id="courseId"
								name="courseId"
								placeholder="Select a Course"
								value={
									coreTest.courseId
										? [
												{
													value: coreTest.courseId,
													label: (
														courseOptions.find(
															(x) =>
																x.key ===
																(coreTest.courseId
																	? coreTest.courseId.toString()
																	: "")
														) || { label: "" }
													).label,
												},
										  ]
										: undefined
								}
								options={courseOptions}
								onChange={this.setCoreTestCourse}
								disabled={dataLocked || this.state.locationId === undefined}
							/>
						</Form.Item>
					</div>
					<div className="col-md-6 col-lg-4 form-group">
						<label>Assigned evaluator *</label>
						<Form.Item
							validateStatus={validCoreTestResult.evaluator.validationStatus}
							help={validCoreTestResult.evaluator.message}
							hasFeedback={true}
							required={true}
						>
							<Dropdown
								id="evaluatorId"
								name="evaluatorId"
								placeholder="Select evaluator"
								value={
									coreTest.evaluatorId
										? [
												{
													value: coreTest.evaluatorId,
													label: (
														evaluatorOptions.find(
															(x) =>
																x.key ===
																(coreTest.evaluatorId
																	? coreTest.evaluatorId.toString()
																	: "")
														) || { label: "" }
													).label,
												},
										  ]
										: undefined
								}
								options={evaluatorOptions}
								onChange={this.setCoreTestProperties}
								disabled={dataLocked}
							/>
						</Form.Item>
					</div>
					<div className="col-md-6 col-lg-4 form-group">
						<label>Difficulty level *</label>
						<Form.Item
							validateStatus={
								validCoreTestResult.difficultyLevel.validationStatus
							}
							help={validCoreTestResult.difficultyLevel.message}
							hasFeedback={true}
							required={true}
						>
							<DropdownInputAnt
								name="difficultyLevelId"
								id="difficultyLevelId"
								required={true}
								value={coreTest.difficultyLevelId!}
								placeholder="Select a difficulty level"
								pickListCode="Difficulty"
								onChange={(value: any) =>
									this.onCoreTestResultChange(value, "difficultyLevelId")
								}
								sort={true}
								disabled={dataLocked}
							/>
						</Form.Item>
					</div>
					<div className="col-md-6 col-lg-4 form-group">
						<label>Weather/Road conditions *</label>
						<Form.Item
							validateStatus={validCoreTestResult.weather.validationStatus}
							help={validCoreTestResult.weather.message}
							hasFeedback={true}
							required={true}
						>
							<DropdownInputAnt
								name="weatherRoadConditionsId"
								id="weatherRoadConditionsId"
								required={true}
								value={coreTest.weatherRoadConditionsId!}
								placeholder="Select a weather/road condition"
								pickListCode="WeatherCondition"
								onChange={(value: any) =>
									this.onCoreTestResultChange(value, "weatherRoadConditionsId")
								}
								sort={true}
								disabled={dataLocked}
							/>
						</Form.Item>
					</div>
					<div className="col-md-6 col-lg-4 form-group">
						<label>Cooperative *</label>
						<Form.Item
							validateStatus={validCoreTestResult.cooperative.validationStatus}
							help={validCoreTestResult.cooperative.message}
							required={true}
							hasFeedback={true}
						>
							<DropdownInputAnt
								name="cooperative"
								id="cooperativeId"
								required={true}
								value={coreTest.cooperativeId!}
								placeholder="Select a cooperative type"
								pickListCode="Cooperative"
								onChange={(value: any) =>
									this.onCoreTestResultChange(value, "cooperativeId")
								}
								sort={true}
								disabled={dataLocked}
							/>
						</Form.Item>
					</div>
					<div className="col-md-6 col-lg-4 form-group">
						<label>Vehicle type *</label>
						<Form.Item
							validateStatus={validCoreTestResult.vehicleType.validationStatus}
							help={validCoreTestResult.vehicleType.message}
							hasFeedback={true}
							required={true}
						>
							<Dropdown
								id="vehicleTypeId"
								name="vehicleTypeId"
								placeholder="Select a vehicle type"
								value={
									coreTest.vehicleTypeId
										? [
												{
													value: coreTest.vehicleTypeId,
													label: (
														vehicleTypeOptions.find(
															(x) =>
																x.key ===
																(coreTest.vehicleTypeId
																	? coreTest.vehicleTypeId.toString()
																	: "")
														) || { label: "" }
													).label,
												},
										  ]
										: undefined
								}
								options={vehicleTypeOptions}
								onChange={this.setCoreTestVehicleType}
								disabled={
									dataLocked ||
									(coreTest.vehicleTypeId !== undefined &&
										coreTest.coreGeneralSubmitted)
								}
							/>
						</Form.Item>
					</div>
					{hasAnyExceleRATEProduct(dataset.productId) &&
					commercialDrivingExpSettings.showCommDrivingExp ? (
						<div className="col-md-6 col-lg-4 form-group">
							<label>
								Commercial Driving Experience{" "}
								{commercialDrivingExpSettings.requireCommDrivingExp ? "*" : ""}
							</label>
							<Form.Item
								validateStatus={validCoreTestResult.commDrvExp.validationStatus}
								help={validCoreTestResult.commDrvExp.message}
								hasFeedback={true}
								required={commercialDrivingExpSettings.requireCommDrivingExp}
							>
								<Dropdown
									id="monthsCommercialDrivingExp"
									name="monthsCommercialDrivingExp"
									value={
										coreTest.monthsCommercialDrivingExp !== undefined
											? [
													{
														value: coreTest.monthsCommercialDrivingExp,
														label: Utils.getCommercialDrivingExpDesc(
															coreTest.monthsCommercialDrivingExp
														),
													},
											  ]
											: undefined
									}
									options={this.commercialDrivingExpOptions}
									onChange={(value: any) =>
										this.onCommercialDrivingExpChange(value)
									}
									placeholder="Exp"
								/>
							</Form.Item>
						</div>
					) : (
						<></>
					)}
				</div>
				<div className="row">
					<CustomFieldContainer
						customFieldTypes={["CoreType"]}
						datasetId={+this.props.match.params.datasetId}
						organizationId={+this.props.match.params.organizationId}
						pickListItems={this.context.pickListItems}
						customFieldTypeIds={{
							typeOfCustomFieldValue: "CoreType",
							value: this.props.match.params.coreId,
						}}
						getCustomFieldValueFromState={this.getCoreTestCustomFieldValues}
						getCustomFieldValidation={this.getCoreCustomFieldValidation}
					/>
				</div>
				<div className="row">
					<div className="col-md-8 col-lg-6 form-group">
						<label htmlFor="comments">Comments</label>
						<Form.Item>
							<Input.TextArea
								id="comments"
								name="comments"
								maxLength={3000}
								value={coreTest.comments}
								onChange={this.onCommentChange}
								disabled={dataLocked}
							/>
						</Form.Item>
					</div>
				</div>
				<div className="form-group">
					<div>
						<Button
							className="btn-outline-primary mr-3"
							onClick={this.toPreviousPage}
						>
							{coreTest.coreGeneralSubmitted ? "Exit" : "Cancel"}
						</Button>
						<Button
							className="btn-primary"
							disabled={!this.isValid(validCoreTestResult)}
							onClick={this.toSkillAppraisal}
						>
							Next
						</Button>
					</div>
				</div>
			</div>
		);
	}

	private commercialDrivingExpOptions = CommercialDrivingExpValueMap.map(
		(x) => {
			return {
				key: x.value.toString(),
				label: x.description.toString(),
			} as DropdownIOption.IOption;
		}
	);

	private onCommercialDrivingExpChange = (e: any) => {
		const coreTest = this.state.coreTest;
		coreTest.monthsCommercialDrivingExp = Number(e.key);
		this.setState({ coreTest });
	};

	// from customfield container
	private getCoreTestCustomFieldValues = (
		customFieldValues: CustomFieldValueDTO[]
	) => {
		const coreTestCustomFieldValues = getCustomFieldValues(customFieldValues);
		const coreTest = this.state.coreTest;
		if (coreTestCustomFieldValues.length > 0) {
			coreTest.coreTestCustomFieldValues = coreTestCustomFieldValues;
			this.setState({ coreTest });
		}

		return;
	};

	private getCoreCustomFieldValidation = (
		validation: ICustomFieldValidation[]
	) => {
		const validCustomFieldValues = getCustomFieldValidation(validation);
		const validCustomFieldValuesValidationStatus = validCustomFieldValues.map(
			(c) => {
				if (c.validationStatus === undefined) {
					// just need to know if its success or error this is an edge case
					return "";
				} else {
					return c.validationStatus;
				}
			}
		);
		this.setState({
			coreTestCustomFieldValidation: validCustomFieldValuesValidationStatus,
		});
	};

	private toPreviousPage = () => {
		const { organizationId, datasetId, clientId } = this.props.match.params;
		const url = `/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/results`;
		this.props.history.push(url);
	};

	private toSkillAppraisal = () => {
		const usedClientId = this.props.match.params.clientId;
		const {
			startTimeHour,
			startTimeMinutes,
			endTimeHour,
			endTimeMinutes,
			startTimeOfDay,
			endTimeOfDay,
		} = this.state;
		const coreTestResult: UpsertCoreTestResultRequest = {
			...this.state.coreTest,
			clientId: usedClientId,
		}; // coreTestCustomFieldValues: this.state.coreTestResult.coreTestCustomFieldValues

		const combinedStartTime = this.convertToTimeValue(
			startTimeHour,
			startTimeMinutes,
			startTimeOfDay
		);
		const combinedEndTime = this.convertToTimeValue(
			endTimeHour,
			endTimeMinutes,
			endTimeOfDay
		);

		coreTestResult.startTime = combinedStartTime;
		coreTestResult.endTime = combinedEndTime;
		coreTestResult.coreGeneralSubmitted = true;
		coreTestResult.datasetId = +this.props.match.params.datasetId;

		CoreAPI.upsertCoreTest(coreTestResult)
			.then(() => this.setState({ isDirty: false }))
			.then(() => this.props.history.push("skills-appraisal"))
			.catch((error) => toast.error("Something went wrong"));
	};

	private convertToTimeValue = (
		hour: number | undefined,
		minutes: number | undefined,
		dayOrNight: number | undefined
	) => {
		const hourValue: PickListItemResponseDTO = this.context.pickListItems.find(
			(pItem: PickListItemResponseDTO) => pItem.id! === hour!
		);
		const minuteValue: PickListItemResponseDTO =
			this.context.pickListItems.find(
				(pItem: PickListItemResponseDTO) => pItem.id! === minutes!
			);
		const timeofDay: PickListItemResponseDTO = this.context.pickListItems.find(
			(pItem: PickListItemResponseDTO) => pItem.id! === dayOrNight!
		);

		return `${hourValue.description}:${minuteValue.description}${timeofDay.description}`;
	};

	private onCoreTestResultChange = (value: any, name: string) => {
		let coreTest = {};
		// ant dropdowns values are objects with a label
		if (typeof value === "object") {
			const dropdownChoice = value.key;
			coreTest = { ...this.state.coreTest, [name]: dropdownChoice };
		} else {
			// regular dropdowns
			coreTest = { ...this.state.coreTest, [name]: value };
		}

		this.setState({ coreTest });
	};

	private convertTestTime = (time: string, testTimeType: string) => {
		// split string to find seperate value Ids from picklist
		const foundColon = time.indexOf(":") + 1;
		const foundTimeValue = time.slice(-2);
		let hour = "";
		const minutes = time.substring(foundColon, time.length - 3);

		let hourValue = {} as PickListItemResponseDTO;
		let minuteValue = {} as PickListItemResponseDTO;
		let timeofDay = {} as PickListItemResponseDTO;
		if (time !== undefined) {
			if (testTimeType === "startTime") {
				hour = time.substring(0, 2);
				hourValue = this.getTimeValue(hour);
				minuteValue = this.getTimeValue(minutes);
				timeofDay = this.getTimeValue(foundTimeValue);

				this.setState({
					startTimeHour: hourValue.id,
					startTimeMinutes: minuteValue.id,
					startTimeOfDay: timeofDay.id,
				});
				return;
			}

			if (testTimeType === "endTime") {
				hour = time.substring(0, 2);
				hourValue = this.getTimeValue(hour);
				minuteValue = this.getTimeValue(minutes);
				timeofDay = this.getTimeValue(foundTimeValue);

				this.setState({
					endTimeHour: hourValue.id,
					endTimeMinutes: minuteValue.id,
					endTimeOfDay: timeofDay.id,
				});
				return;
			}
		}
	};

	private getTimeValue = (time: string) => {
		const timeValue = this.context.pickListItems.find(
			(pItem: PickListItemResponseDTO) => pItem.description === time
		);
		return timeValue;
	};

	private onStartAndEndTimeChange = (e: any, name: string) => {
		const val = e.key;
		switch (name) {
			case "startTimeHour":
				this.setState({ startTimeHour: val });
				break;
			case "startTimeMinutes":
				this.setState({ startTimeMinutes: val });
				break;
			case "startTimeOfDay":
				this.setState({ startTimeOfDay: val });
				break;
			case "endTimeHour":
				this.setState({ endTimeHour: val });
				break;
			case "endTimeMinutes":
				this.setState({ endTimeMinutes: val });
				break;
			case "endTimeOfDay":
				this.setState({ endTimeOfDay: val });
				break;
		}
		return;
	};

	private onCommentChange = (event: any) => {
		const value = event.target.value;
		const coreTest = {
			...this.state.coreTest,
			comments: value,
		};

		this.setState({ coreTest });
	};

	private setCoreTestCourse = (e: any) => {
		const courseId = Number(e.key);
		if (courseId) {
			const coreTest = { ...this.state.coreTest, courseId };
			this.setState({ coreTest, courseId });
		}
	};

	private setCoreTestLocation = (e: any) => {
		const locationId = Number(e.key);
		const courseId = undefined;
		if (locationId) {
			const coreTest = { ...this.state.coreTest, locationId, courseId };
			this.setState({ coreTest, locationId, courseId });
		}
	};

	private setCoreTestVehicleType = (e: any) => {
		const vehicleTypeId = Number(e.key);
		if (vehicleTypeId) {
			const coreTest = { ...this.state.coreTest, vehicleTypeId };
			this.setState({ coreTest, vehicleTypeId });
		}
	};

	private setCoreTestProperties = (e: any) => {
		const name = "evaluatorId";
		const value = Number(e.key);
		const coreTest = { ...this.state.coreTest, [name]: value };
		this.setState({ coreTest });
	};

	private setLocationOptions = (items: any[]) => {
		const newOptions = items
			.filter((c) => c.isActive === true)
			.map((item) => {
				return {
					key: item.id.toString(),
					label: item.name!.toString(),
				} as DropdownIOption.IOption;
			});

		return newOptions;
	};

	private setVehicleTypeOptions = (items: any[]) => {
		const newOptions = items
			.filter((c) => c.isActive === true)
			.map((item) => {
				return {
					key: item.id.toString(),
					label: item.description!.toString(),
				} as DropdownIOption.IOption;
			});

		return newOptions;
	};

	private setCourseOptions = (items: any[]) => {
		const newOptions = items
			.filter(
				(c) => c.isActive === true && c.locationId === this.state.locationId
			)
			.map((item) => {
				return {
					key: item.id.toString(),
					label: item.name!.toString(),
				} as DropdownIOption.IOption;
			});

		return newOptions;
	};

	private setEvaluatorOptions = (items: any[]) => {
		const newOptions = items.map((item) => {
			return {
				key: item.id.toString(),
				label: `${item.firstName} ${item.lastName}`,
			} as DropdownIOption.IOption;
		});

		return newOptions;
	};

	private onDateChange = (value: any) => {
		const savedValue = value.format("MMM DD, YYYY"); // dateAdministered is a String
		const coreTest = { ...this.state.coreTest, dateAdministered: savedValue };
		this.setState({ coreTest });
	};

	private isValid = (validCoreTest: any) => {
		return Validation.isValidIncludingCustomFields(
			validCoreTest,
			"coreTestCustomFieldValues"
		);
	};
}
export default CoreGeneral;
